import { EnumResolver } from "../../../common/tables/etc/EnumResolver";
import {
    CostPayoutModifierTableRow
} from "../../../../../common/tables/cost-payout-modifier/CostPayoutModifierTableRow";
import { EnumMapper } from "../../../common/tables/etc/EnumMapper";
import { ConditionIsBundleMapper } from "./mappers/ConditionIsBundleMapper";

export class CPMEnumMapper extends EnumResolver<CostPayoutModifierTableRow> {
    public resolveEnum(columnName: keyof CostPayoutModifierTableRow): EnumMapper {
        switch (columnName) {
            case "conditionIsBundle":
                return new ConditionIsBundleMapper();
            default:
                return {} as EnumMapper;
        }
    }
}
